module.exports = __webpack_public_path__ + "img/T1B_rc_3.51d8655d.png";